import api from "./apiService";
import { parseConsistentApiResponse } from "../utils/consistentApiParser";

const channelService = {
  // Get all channels
  getAll: async () => {
    const response = await api.get("/channels");

    // Parse the consistent API response
    const apiResponse = parseConsistentApiResponse(response, "channelService", "getAll");

    // Return the data directly (should be an array of channels)
    return apiResponse.data || [];
  },

  // Get channel by ID
  getById: async (id) => {
    const response = await api.get(`/channels/${id}`);

    // Parse the consistent API response
    const apiResponse = parseConsistentApiResponse(response, "channelService", "getById");

    // Return the data directly (should be a single channel object)
    return apiResponse.data;
  },

  // Create new channel
  create: async (channelData) => {
    const response = await api.post("/channels", channelData);

    // Parse the consistent API response
    const apiResponse = parseConsistentApiResponse(response, "channelService", "create");

    // Return the data directly (should be the created channel object)
    return apiResponse.data;
  },

  // Update channel
  update: async (id, channelData) => {
    const response = await api.put(`/channels/${id}`, channelData);

    // Parse the consistent API response
    const apiResponse = parseConsistentApiResponse(response, "channelService", "update");

    // Return the data directly (should be the updated channel object)
    return apiResponse.data;
  },

  // Delete channel
  remove: async (id) => {
    const response = await api.delete(`/channels/${id}`);

    // Parse the consistent API response
    const apiResponse = parseConsistentApiResponse(response, "channelService", "remove");

    // For delete operations, return the ID if successful
    if (apiResponse.success) {
      return id;
    }

    return apiResponse;
  },

  // Get all users with access to a channel (ADMIN only)
  getChannelUsers: async (channelId) => {
    const response = await api.get(`/channels/${channelId}/users`);
    const apiResponse = parseConsistentApiResponse(response, "channelService", "getChannelUsers");
    return apiResponse.data || [];
  },

  // Grant/update a user's access to a channel (ADMIN only)
  setChannelUserAccess: async (channelId, userId) => {
    const response = await api.put(`/channels/${channelId}/users/${userId}`);
    const apiResponse = parseConsistentApiResponse(response, "channelService", "setChannelUserAccess");
    return apiResponse.data;
  },

  // Remove a user's access to a channel (ADMIN only)
  removeChannelUserAccess: async (channelId, userId) => {
    const response = await api.delete(`/channels/${channelId}/users/${userId}`);
    const apiResponse = parseConsistentApiResponse(response, "channelService", "removeChannelUserAccess");
    return apiResponse.success ? userId : apiResponse;
  },
};

export default channelService;
